export default "dist/images/block-call-to-action-basic.97e9e3b.png";